/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_QuestionInputs */

const en_scene_outside_question = /** @type {(inputs: Scene_Outside_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which purchase orders are still waiting for a supplier?`)
};

/**
* | output |
* | --- |
* | "Which purchase orders are still waiting for a supplier?" |
*
* @param {Scene_Outside_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_question = /** @type {((inputs?: Scene_Outside_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_question(inputs)
});